<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />
			<vs-row class="pt-5">
				<div class="w-full md:w-1/4 lg:w-2/12 mb-5 md:mb-0 md:pr-2">
					<img :src="getUrlOfFile(vars.image, true)" alt="image-profile" class="w-3/4 md:w-full block m-auto">
					<vs-button color="primary" type="border" icon="upload_file" class="w-full mt-3 p-1" @click="$refs.file_upload.click()">
						<span class="text-xs">Upload Image</span>
					</vs-button>
					<input ref="file_upload" type="file" accept="image/png, image/gif, image/jpeg, image/jpg"
						v-on:change="AddPhoto" hidden />
				</div>
				<div class="w-full lg:w-5/12 md:px-3">
					<div class="w-full mb-5">
						<vs-input
								autocomplete="off"
								v-validate="'required'"
								label="Title"
								name="title"
								type="text"
								v-model="models.title"
								class="w-full"/>
						<span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
					</div>
					<div class="w-full mb-5">
						<vs-textarea label="Body" name="body"  v-validate="'required'"  v-model="models.body" rows="4"/>
						<span class="text-danger text-sm" v-show="errors.has('body')">{{ errors.first('body') }}</span>
					</div>
					<div class="w-full my-5">
						<label class="pl-2 text-sm" for="segment">Segment</label>
						<select name="segment" v-validate="'required'" @change="selectSegmen"  class="w-full" v-model="models.segmen">
							<option value="">Select Segment</option>
							<option :value="1">All User</option>
							<option :value="2">New User (joined on last 30 days)</option>
							<option :value="3">User that have limit join campaign < 5</option>
							<option :value="4">Tier</option>
							<option :value="5">Community</option>
							<option :value="6">Status</option>
						</select>
						<span class="text-danger text-sm" v-show="errors.has('segment')">{{ errors.first('segment') }}</span>
					</div>
					<div v-if="models.segmen == 4" class="w-full my-5">
						<label class="pl-2 text-sm" for="tier">Tier</label>
						<v-select
							class="w-full"
							v-validate="'required'"
							name="tier"
							:options="vars.tiers"
							label="name"
							:reduce="(v) => v.id"
              key="tier"
							v-model="models.tiers"
							multiple
						/>
						<span class="text-danger text-sm" v-show="errors.has('tier')">{{ errors.first('tier') }}</span>
					</div>
					<div v-if="models.segmen == 5" class="w-full my-5">
						<label class="pl-2 text-sm" for="community">Community</label>
						<v-select
							class="w-full"
							v-validate="'required'"
							name="community"
							:options="vars.communities"
							label="name"
							:reduce="(v) => v.id"
              key="community"
							v-model="models.communities"
							multiple
						/>
						<span class="text-danger text-sm" v-show="errors.has('community')">{{ errors.first('community') }}</span>
					</div>
					<div v-if="models.segmen == 6" class="w-full my-5">
						<label class="pl-2 text-sm" for="maritalstatus">Status</label>
						<v-select
							class="w-full"
							v-validate="'required'"
							name="maritalstatus"
							:options="vars.maritalStatus"
							label="name"
							:reduce="(v) => v.id"
              key="maritalstatus"
							v-model="models.maritalStatus"
						/>
						<span class="text-danger text-sm" v-show="errors.has('maritalstatus')">{{ errors.first('maritalstatus') }}</span>
					</div>
					<div class="w-full my-5">
						<label class="pl-2 text-sm" for="isManual">Send Manual</label>
						<ul id="isManual" class="flex mt-3">
							<li>
								<vs-radio v-model="models.isManual" vs-name="isManual" :vs-value="true" class="mr-5">Yes</vs-radio>
							</li>
							<li>
								<vs-radio v-model="models.isManual" vs-name="isManual" :vs-value="false">No</vs-radio>
							</li>
						</ul>
						<span class="text-danger text-sm" v-show="errors.has('isManual')">{{ errors.first('isManual') }}</span>
					</div>
					<div  class="w-full mb-5">
						<vs-input v-if="models.isManual === false"
							autocomplete="off"
							v-validate="'required'"
							label="Date Send"
							name="date"
							type="date"
							v-model="models.date"
							:min="vars.end_date"
							class="w-full"
						/>
						<span class="text-danger text-sm" v-show="errors.has('date')">{{ errors.first('date') }}</span>
					</div>
					<div class="w-full my-5">
						<label class="pl-2 text-sm" for="type">Type</label>
						<select name="type" @change="models.refId = null" v-validate="'required'"  class="w-full" v-model="models.type">
							<option value="">Select Type</option>
							<option :value="1">Campaign</option>
							<option :value="2">Event</option>
							<option :value="3">Product</option>
							<option :value="4">Leaderboard</option>
							<option :value="5">Url</option>
						</select>
						<span class="text-danger text-sm" v-show="errors.has('type')">{{ errors.first('type') }}</span>
					</div>
					<div v-if="models.type == 1" class="w-full my-5">
						<label class="pl-2 text-sm" for="segment">Campaign</label>
						<v-select
							class="w-full"
							name="campaign"
							:options="vars.campaigns"
							label="title"
							:reduce="(v) => v.id"
							v-model="models.refId"
						/>
						<span class="text-danger text-sm" v-show="errors.has('campaign')">{{ errors.first('campaign') }}</span>
					</div>
					<div v-if="models.type == 2" class="w-full my-5">
						<label class="pl-2 text-sm" for="event">Event</label>
						<v-select
							class="w-full"
							name="event"
							:options="vars.events"
							label="name"
							:reduce="(v) => v.id"
							v-model="models.refId"
						/>
						<span class="text-danger text-sm" v-show="errors.has('event')">{{ errors.first('event') }}</span>
					</div>
					<div v-if="models.type == 3" class="w-full my-5">
						<label class="pl-2 text-sm" for="product">Product</label>
						<v-select
							class="w-full"
							name="product"
							:options="vars.products"
							label="name"
							:reduce="(v) => v.id"
							v-model="models.refId"
						/>
						<span class="text-danger text-sm" v-show="errors.has('product')">{{ errors.first('product') }}</span>
					</div>
					<div v-if="models.type == 4" class="w-full my-5">
						<label class="pl-2 text-sm" for="leaderboard">Leaderboard</label>
						<v-select
							class="w-full"
							name="leaderboard"
							:options="vars.leaderboards"
							label="name"
							:reduce="(v) => v.id"
							v-model="models.refId"
						/>
						<span class="text-danger text-sm" v-show="errors.has('leaderboard')">{{ errors.first('leaderboard') }}</span>
					</div>

					<div v-if="models.type == 5" class="w-full mb-5">
						<vs-input
							autocomplete="off"
							label="Url"
							name="url"
							type="text"
							v-model="models.url"
							class="w-full"/>
						<span class="text-danger text-sm" v-show="errors.has('url')">{{ errors.first('url') }}</span>
					</div>
				</div>
			</vs-row>

			<div slot="footer" class="justify-center">
				<vs-button button="submit" color="primary" type="filled" class="mr-3">Save</vs-button>
				<vs-button @click="$router.go(-1)" color="rgb(172,172,172)" type="border">Cancel</vs-button>
			</div>
		</vs-card>
	</form>
</template>

<script>
	import api from '@/utils/api.js'
	import {
		getUrlOfFile,
		uploadFile
	} from '@/utils/helpers.js';
	import moment from "moment";

	export default {
		name: 'FormNotification',
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					title: '',
					body: '',
					image: '',
					url: '',
					type: '',
					segmen: "",
					isManual: false,
					date: null,
					refId: null,
					tiers: [],
					communities: [],
          maritalStatus: null,
				},
				vars: {
					image: '',
					campaigns: [],
					events: [],
					products: [],
					leaderboards: [],
					tiers: [],
					communities: [],
					end_date: moment().add(1, 'days').format("YYYY-MM-DD"),
          maritalStatus: [
            { id: 1, name: 'Single' },
            { id: 2, name: 'Menikah' },
            { id: 3, name: 'Punya Anak' },
          ]
				},
				getUrlOfFile
			}
		},
		created() {
			this.getById();
			this.getCampaigns();
			this.getEvents();
			this.getProducts();
			this.getLeaderboards();
			this.getTiers();
			this.getCommunities();
		},
		methods: {
			getById() {
				if (this.$route.params.id) {
					this.$axios.get(`${api.notification}/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							this.vars.image = data.image;
							this.models.title = data.title;
							this.models.body = data.body;
							this.models.url = data.url;
							this.models.type = parseInt(data.type);
							this.models.segmen = parseInt(data.segmen);
							this.models.isManual = data.isManual;
							this.models.date =  data.date ? moment(data.date).format("YYYY-MM-DD") : null;
							this.models.refId = data.refId;
							this.models.communities = data.communities;
							this.models.tiers = data.tiers;
              this.models.maritalStatus = data.maritalStatus || null;
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},
			getCampaigns() {
				this.$axios
					.get(`${api.misc_campaigns}`)
					.then(res => {
						const { data } = res.data;
						this.vars.campaigns = data;
					});
			},
			getEvents() {
				this.$axios
					.get(`${api.misc_events}`)
					.then(res => {
						const { data } = res.data;
						this.vars.events = data;
					});
			},
			getProducts() {
				this.$axios
					.get(`${api.misc_products}`)
					.then(res => {
						const { data } = res.data;
						this.vars.products = data;
					});
			},
			getLeaderboards() {
				this.$axios
					.get(`${api.leaderboard}`,{
						params: {
							period: 'month'
						}
					})
					.then(res => {
						const { data } = res.data;
						this.vars.leaderboards = data.rows;
					});
			},
			getTiers() {
				this.$axios
					.get(`${api.mics_tiers}`)
					.then(res => {
						const { data } = res.data;
						this.vars.tiers = data;
					});
			},
			getCommunities() {
				this.$axios
					.get(`${api.community}`, {
						params: {
							page: 1,
							limit: 1000
						}
					})
					.then(res => {
						const { data } = res.data;
						this.vars.communities = data.rows;
					});
			},
			AddPhoto(event) {
				let fileSizeLimit = 1024 * 1024 * 2; // limit 2 MB
				if(event.target.files[0].size < fileSizeLimit) {
					this.vars.image = event.target.files[0];
				} else {
					this.$showToast('Failed', `Max file size is 2 MB`, 'danger')
				}
			},
			selectSegmen(){
				this.models.tiers = [];
				this.models.communities = [];
        		this.models.maritalStatus = null;
			},
			save() {
				this.$validator.validate().then(async valid => {
					if (valid) {
						let msg = '';
						if(this.models.type != 4 && this.models.type != 5 && !this.models.refId){
							switch(this.models.type){
								case 1:
									msg = 'Campaign';
								break;
								case 2:
									msg = 'Event';
								break;
								case 3:
									msg = 'Product';
								break;
							}
						}
						if(this.models.type == 5 && !this.models.url){
							msg = 'Url';
						}

						if(msg){
							this.$refs.response.setResponseCustom(msg + ' is required', 'danger')
						} else {
							let request = "";
							let message = "create";

							if (!this.models.maritalStatus) {
								this.models.maritalStatus = null;
							}

							this.models.image = typeof this.vars.image === 'string' ? this.vars.image : await uploadFile(this.vars.image)

							if (!this.$route.params.id) {
								request = this.$axios.post(api.notification, this.models);
							} else {
								message = "update"
								request = this.$axios.put(`${api.notification}/${this.$route.params.id}`, this.models);
							}
							request
								.then(() => {
									this.$showToast('Success', `Success ${message} notification`,)
									this.$router.push({
										name: this.config.uri
									})
								})
								.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
						}
					} else {
						console.log(this.$validator.errors);
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>
